// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"d07261bc971de990","1836":"272c7026a627d7e1","5735":"beb578cc985d134d"}[chunkId] + ".css";
};